import { render, staticRenderFns } from "./BidSpecification.vue?vue&type=template&id=5fa7f8a5&"
import script from "./BidSpecification.vue?vue&type=script&lang=js&"
export * from "./BidSpecification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports